const dict = {
  uk: {
    account: 'Акаунт',
    logout: 'Вихід',
    activeAccount: 'Активний акаунт',
    otherAccounts: 'Інші акаунти',
    addAccount: 'Додати акаунт',
    logoutFromAccount: 'Вийти з цього акаунту',
  },
  en: {
    account: 'Account',
    logout: 'Log out',
    activeAccount: 'Active account',
    otherAccounts: 'Other accounts',
    addAccount: 'Add account',
    logoutFromAccount: 'Log out of this account',
  },
};

export default dict;
